import React, { useState } from "react";
import "./Dashboard.css";
import { apiFetch } from "./config";
import GenerateButton from "./components/generate_button/generate_button";
import ChooseProf from "./components/choose_prof/choose_prof";
import ChooseWeek from "./components/choose_week/choose_week";
import ChooseEtape from "./components/choose_etape/choose_etape";
import ImportFeuille from "./components/import_feuille/import_feuille";
// import ChooseTp from "./components/choose_tp/choose_tp";
// import ChooseSpecialite from "./components/choose_specialite/choose_specialite";
// import ChooseVa from "./components/choose_va/choose_va";

function Dashboard() {

  // const [selectedSpecialite, setSelectedSpecialite] = useState("");
  const [selectedWeek, setSelectedWeek] = useState("");
  const [selectedProf, setSelectedProf] = useState("");
  const [selectedEtape, setSelectedEtape] = useState("");

  const lancerGeneration = async (route) => {
    if (!selectedProf || !selectedWeek) {
      alert("Veuillez sélectionner un professeur et une semaine");
      return;
    }
    try {
      const response = await apiFetch(
        `/${route}?prof=${encodeURIComponent(selectedProf)}&semaine=${encodeURIComponent(selectedWeek)}`
      );
      const contentType = response.headers.get("Content-Type") || "";
      if (contentType.includes("application/pdf")) {
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        const disposition = response.headers.get("Content-Disposition") || "";
        const match = disposition.match(/filename="(.+?)"/);
        a.href = url;
        a.download = match ? match[1] : "emargement.pdf";
        a.click();
        URL.revokeObjectURL(url);
      } else {
        const data = await response.json();
        alert(data.message);
      }
    } catch (error) {
      console.error(error);
      alert("Erreur lors de l'appel au backend");
    }
  };

  const lancerGenerationEtape = async () => {
    if (!selectedEtape || !selectedWeek) {
      alert("Veuillez sélectionner une étape et une semaine");
      return;
    }
    try {
      const response = await apiFetch(
        `/generation_pdf_etape?etape=${encodeURIComponent(selectedEtape)}&semaine=${encodeURIComponent(selectedWeek)}`
      );
      const contentType = response.headers.get("Content-Type") || "";
      if (contentType.includes("application/pdf")) {
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        const disposition = response.headers.get("Content-Disposition") || "";
        const match = disposition.match(/filename="(.+?)"/);
        a.href = url;
        a.download = match ? match[1] : "emargement_etape.pdf";
        a.click();
        URL.revokeObjectURL(url);
      } else {
        const data = await response.json();
        alert(data.message);
      }
    } catch (error) {
      console.error(error);
      alert("Erreur lors de l'appel au backend");
    }
  };

  return (
    <div className="Dashboard">
      <div className="buttons_container">
        <ChooseProf   selectedProf={selectedProf} setSelectedProf={setSelectedProf}/>
        <ChooseWeek selectedWeek={selectedWeek} setSelectedWeek={setSelectedWeek} />
        <ChooseEtape selectedEtape={selectedEtape} setSelectedEtape={setSelectedEtape} />
        <GenerateButton onClick={() => lancerGeneration("generation_pdf")} label="Générer (QR Code)" />
        <GenerateButton onClick={() => lancerGeneration("generation_pdf_main")} label="Générer (Main)" />
        <GenerateButton onClick={lancerGenerationEtape} label="Générer étape (QR Code)" />
      </div>
      <ImportFeuille prof={selectedProf} semaine={selectedWeek} />
    </div>
  );
}

export default Dashboard;